module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-6.d2815bb9.jpg";